import axios from "axios";
import {
  BUSINESS_GROUP,
  INDUSTRY_TYPE,
  LEAD_SOURCE,
  LEAD_STATUSES,
  GET_RATING,
  GET_COMPANIES,
  GET_Countries,
  GET_COUNTRIES,
  GET_STATES,
  GET_CITY,
  GET_COMPANY_TYPES,
  GET_COMPANY_OWNERSHIP_TYPES,
  GET_CALL_PURPOSE_TYPES,
  GET_CALL_OUTCOME_TYPES,
  GET_PRIORITIES_LOSS_REASONS,
  GET_COMPANY_MODULES,
  GET_CONTACT_DEPARTMENTS,
  GET_CONTACT_GROUPS,
  GET_CONTACT_TYPES,
  GET_MODULES,
  GET_TASK_STATUSES,
  GET_LEAD_STAGES,
  GET_PRIORITIES,
  GET_CIF_FOB_LIST,
  GET_SHIPMENT_TYPES,
  GET_CURRENCY_LIST,
  GET_SUPPLIERS_LIST,
  GET_clientCompanies,
  GET_LEAD_OWNER,
  GET_CONTACT_PERSON_LIST,
  GET_SHIPPING_LINE,
  GET_FCL_LIST,
  GET_DIRECT_LIST,
  GET_FREIGHT_FORWARD_AGENCY_LIST,
  GET_CUSTOM_CLEARING_AGENCY_LIST,
  GET_PAYMENT_TYPE_LIST,
  GET_EXPENSE_LEDGER_LIST,
  GET_TITLES,
  GET_SHIPPING_STATUS,
  GET_UNIT_QUALITY_CODE,
  GET_UNIT_LIST,
  GET_VOUCHER,
  GET_RECEIPT_TYPE_LIST,
  GET_PRODUCTS_GROUP,
  PAYMENT_METHOD,
  GET_DOCUMENT_NAME_LIST,
  GET_COLOR_PLATE,
  GET_CALL_TYPE,
  GET_ORG_USERS,
  GET_PAYMENT_AGAINST,
  ENQUIRY_COMPANY_LIST,
  GET_PORT_MASTERS,
  GET_PARTY_LEDGER_LIST,
  GET_PAYMENT_TO_LIST,
  GET_COMPANY,
  GET_ALEXXCANSOLS_CONTACT_PERSON_LIST,
  BLOG_STATUS_LIST,
  BLOG_CATEGORY_LIST
} from "./apiRoutes";
import { genericGet } from "./apiServices";
import { genericPost } from "./authServices";

const getIndustryType = async () => {
  try {
    const response = await genericGet({ url: INDUSTRY_TYPE });
    if (response.data) {
      let newData = response.data?.industryTypes.map((data) => ({
        id: data.industryTypeId,
        title: data.industryTypeName,
      }));
      return newData || [];
    } else {
      return [];
    }
  } catch {
    return [];
  }
};

const getTitles = async () => {
  try {
    const response = await genericGet({ url: GET_TITLES });
    if (response.data) {
      let newData = response.data?.titles.map((data) => ({
        id: data.titleId,
        title: data.titleName,
      }));
      return newData || [];
    } else {
      return [];
    }
  } catch {
    return [];
  }
};
const getCallType = async () => {
  try {
    const response = await genericGet({ url: GET_CALL_TYPE });
    if (response.data) {
      let newData = response.data?.callType.map((data) => ({
        id: data.callTypeId,
        title: data.callName,
      }));
      return newData || [];
    } else {
      return [];
    }
  } catch {
    return [];
  }
};
const getPaymentAgainst = async () => {
  try {
    const response = await genericGet({ url: GET_PAYMENT_AGAINST });
    if (response.data) {
      let newData = response.data?.PaymentAgainst.map((data) => ({
        id: data.paymentAgainstId,
        title: data.title,
      }));
      return newData || [];
    } else {
      return [];
    }
  } catch {
    return [];
  }
};

const getBusinessGroup = async () => {
  try {
    const response = await genericGet({ url: BUSINESS_GROUP });
    if (response.data) {
      let newData = response.data?.businessGroups.map((data) => ({
        id: data.businessGroupId,
        title: data.businessGroupName,
      }));
      return newData || [];
    } else {
      return [];
    }
  } catch {
    return [];
  }
};
const getLeadSource = async () => {
  try {
    const response = await genericGet({ url: LEAD_SOURCE });
    if (response.data) {
      let newData = response.data?.leadSources.map((data, index) => ({
        index: (index + 1).toString().padStart(2, '0'),
        id: data.leadSourceId,
        title: data.leadSourceName,
        priority: data?.priority,
        colorId: data.colorId,
        color: data.ColorPlate?.color || '#000',
        backgroundColor: data.ColorPlate?.backgroundColor || '#fff',
      }));
      return newData || [];
    } else {
      return [];
    }
  } catch {
    return [];
  }
};

const getLeadStatus = async () => {
  try {
    const response = await genericGet({ url: LEAD_STATUSES });
    if (response.data) {
      let newData = response.data?.leadStatuses.map((data, index) => ({
        index: (index + 1).toString().padStart(2, '0'),
        id: data.leadStatusId,
        title: data.leadStatusName,
        priority: data?.priority,
        colorId: data.colorId,
        color: data.ColorPlate?.color || '#000',
        backgroundColor: data.ColorPlate?.backgroundColor || '#fff',
      }));
      return newData || [];
    } else {
      return [];
    }
  } catch {
    return [];
  }
};

const getColorPlate = async () => {
  try {
    const response = await genericGet({ url: GET_COLOR_PLATE });
    if (response.data && response.data.colorPlate) {
      let newData = response.data.colorPlate.map((data, index) => ({
        index: (index + 1).toString().padStart(2, '0'),
        colorId: data.colorId,
        colorName: data?.colorName,
        backgroundColor: data?.backgroundColor,
        color: data?.color,
      }));
      return newData || [];
    } else {
      return [];
    }
  } catch {
    return [];
  }
};

const getRating = async () => {
  try {
    const response = await genericGet({ url: GET_RATING });
    if (response.data) {
      let newData = response.data?.ratings.map((data, index) => ({
        index: (index + 1).toString().padStart(2, '0'),
        id: data.ratingId,
        priority: data?.priority,
        title: data?.ratingName,
        colorId: data.colorId,
        color: data.ColorPlate?.color || '#000',
        backgroundColor: data.ColorPlate?.backgroundColor || '#fff',

      }));
      return newData || [];
    } else {
      return [];
    }
  } catch {
    return [];
  }
};

const getCompanies = async () => {
  try {
    const response = await genericGet({ url: GET_COMPANIES });
    if (response.data && response.data.companies) {
      let newData = response.data.companies.map((data) => ({
        id: data.companyId,
        title: data.companyName,

      }));
      return newData || [];
    } else {
      return [];
    }
  } catch (error) {
    console.error("Failed to fetch companies:", error);
    return [];
  }
};


const getCountries = async () => {
  try {
    const response = await genericGet({ url: GET_COUNTRIES });
    if (response.data) {
      let newData = response.data?.country.map((data) => ({
        id: data.id,
        title: data.name,
        phonecode: data.phonecode,

      }));
      return newData || [];
    } else {
      return [];
    }
  } catch {
    return [];
  }
};

const getStates = async ({ id }) => {
  try {
    const response = await genericGet({ url: `${GET_STATES}/${id}/states` });
    if (response.data) {
      let newData = response.data?.states.map((data) => ({
        id: data.id,
        title: data.name,

      }));
      return newData || [];
    } else {
      return [];
    }
  } catch {
    return [];
  }
};

const getCities = async ({ id }) => {
  try {
    const response = await genericGet({ url: `${GET_CITY}/${id}/cities` });
    if (response.data) {
      let newData = response.data?.cities.map((data) => ({
        id: data.id,
        title: data.name,

      }));
      return newData || [];
    } else {
      return [];
    }
  } catch {
    return [];
  }
};

const getCompanyTypes = async () => {
  try {
    const response = await genericGet({ url: GET_COMPANY_TYPES });
    if (response.data && response.data.companyTypes) {
      const newData = response.data.companyTypes.map((data) => ({
        id: data.companyTypeId,
        title: data.companyTypeName,
      }));
      return newData;
    } else {
      return [];
    }
  } catch (error) {
    console.error("Error fetching company types:", error);
    return [];
  }
};

const getCompanyOwnershipType = async () => {
  try {
    const response = await genericGet({ url: GET_COMPANY_OWNERSHIP_TYPES });
    if (response.data && response.data.ownershipTypes) {
      const newData = response.data.ownershipTypes.map((data) => ({
        id: data.ownershipTypeId,
        title: data.ownershipTypeName,
      }));
      return newData;
    } else {
      return [];
    }
  } catch (error) {
    console.error("Error fetching company ownership types:", error);
    return [];
  }
};

const getCallPurposeType = async () => {
  try {
    const response = await genericGet({ url: GET_CALL_PURPOSE_TYPES });
    if (response.data && response.data.callPurposes) {
      const newData = response.data.callPurposes.map((data) => ({
        id: data.callPurposeId,
        title: data.callPurposeName,
      }));
      return newData;
    } else {
      return [];
    }
  } catch (error) {
    console.error("Error fetching call purposes:", error);
    return [];
  }
};

const getCallOutcomeType = async () => {
  try {
    const response = await genericGet({ url: GET_CALL_OUTCOME_TYPES });
    if (response.data && response.data.callOutcomes) {
      const newData = response.data.callOutcomes.map((data) => ({
        id: data.callOutcomeId,
        title: data.callOutcomeName,
      }));
      return newData;
    } else {
      return [];
    }
  } catch (error) {
    console.error("Error fetching call outcomes:", error);
    return [];
  }
};


const getPrioritiesLossReasons = async () => {
  try {
    const response = await genericGet({ url: GET_PRIORITIES_LOSS_REASONS });
    if (response.data && response.data.lossReasons) {
      const newData = response.data.lossReasons.map((data) => ({
        id: data.lossReasonId,
        title: data.lossReasonName,
      }));
      return newData;
    } else {
      return [];
    }
  } catch (error) {
    console.error("Error fetching loss reasons:", error);
    return [];
  }
};

const getPaymentMethod = async () => {
  try {
    const response = await genericGet({ url: PAYMENT_METHOD });
    if (response.data && response.data.paymentMethod) {
      const newData = response.data.paymentMethod.map((data) => ({
        id: data.paymentMethodId,
        title: data.paymentMethodName,
      }));
      return newData;
    } else {
      return [];
    }
  } catch (error) {
    console.error("Error fetching loss reasons:", error);
    return [];
  }
};
const getDocumentNameList = async () => {
  try {
    const response = await genericGet({ url: GET_DOCUMENT_NAME_LIST });
    if (response.data && response.data.data) {
      const newData = response.data.data.map((data) => ({
        id: data.documentId,
        title: data.title,
        createdAt: data.createdAt,
        updatedAt: data.updatedAt,
      }));
      return newData;
    } else {
      return [];
    }
  } catch (error) {
    console.error("Error fetching document names:", error);
    return [];
  }
};


const getCompanyModules = async () => {
  try {
    const response = await genericGet({ url: GET_COMPANY_MODULES });
    if (response.data && response.data.companyModules) {
      const newData = response.data.companyModules.map((data) => ({
        // Assuming each module object has an id and title, replace these fields with actual keys
        id: data.moduleId,
        title: data.moduleName,
      }));
      return newData;
    } else {
      return [];
    }
  } catch (error) {
    console.error("Error fetching company modules:", error);
    return [];
  }
};

const getContactDepartments = async () => {
  try {
    const response = await genericGet({ url: GET_CONTACT_DEPARTMENTS });
    if (response.data && response.data.contactDepartments) {
      const newData = response.data.contactDepartments.map((data) => ({
        id: data.contactDepartmentId,
        title: data.contactDepartmentName,
      }));
      return newData;
    } else {
      return [];
    }
  } catch (error) {
    console.error("Error fetching contact departments:", error);
    return [];
  }
};

const getContactGroups = async () => {
  try {
    const response = await genericGet({ url: GET_CONTACT_GROUPS });
    if (response.data && response.data.contactGroups) {
      const newData = response.data.contactGroups.map((data) => ({
        id: data.contactGroupId,
        companyId: data.companyId,
        title: data.contactGroupName,
        priority: data.priority,
        status: data.status,
      }));
      return newData;
    } else {
      return [];
    }
  } catch (error) {
    console.error("Error fetching contact groups:", error);
    return [];
  }
};

const getContactTypes = async () => {
  try {
    const response = await genericGet({ url: GET_CONTACT_TYPES });
    if (response.data && response.data.contactTypes) {
      const newData = response.data.contactTypes.map((data) => ({
        id: data.contactTypeId,
        companyId: data.companyId,
        title: data.contactTypeName,
        priority: data.priority,
        status: data.status,
      }));
      return newData;
    } else {
      return [];
    }
  } catch (error) {
    console.error("Error fetching contact types:", error);
    return [];
  }
};

const getModules = async () => {
  try {
    const response = await genericGet({ url: GET_MODULES }); // Adjust the URL to your endpoint
    if (response.data && response.data.modules) {
      const newData = response.data.modules.map((module) => ({
        id: module.moduleId,
        title: module.moduleName,
        priority: module.priority,
        status: module.status,
      }));
      return newData;
    } else {
      return [];
    }
  } catch (error) {
    console.error("Error fetching modules:", error);
    return [];
  }
};

const getTaskStatuses = async () => {
  try {
    const response = await genericGet({ url: GET_TASK_STATUSES });
    if (response.data && response.data.taskStatuses) {
      const newData = response.data.taskStatuses.map((status) => ({
        id: status.taskStatusId,
        title: status.taskStatusName,
        priority: status.priority,
        status: status.status,
      }));
      return newData;
    } else {
      return [];
    }
  } catch (error) {
    console.error("Error fetching task statuses:", error);
    return [];
  }
};

const getLeadStages = async () => {
  try {
    const response = await genericGet({ url: GET_LEAD_STAGES });
    if (response.data && response.data.leadStages) {
      const newData = response.data.leadStages.map((stage) => ({
        id: stage.stageId,
        title: stage.stageName,
        priority: stage.priority,
        status: stage.status,
      }));
      return newData;
    } else {
      return [];
    }
  } catch (error) {
    console.error("Error fetching lead stages:", error);
    return [];
  }
};

const getPriorities = async () => {
  try {
    const response = await genericGet({ url: GET_PRIORITIES });
    if (response.data && response.data.priorities) {
      const newData = response.data.priorities.map((priority) => ({
        id: priority.priorityId,
        title: priority.priorityName,
        priority: priority.priority,
        status: priority.status,
      }));
      return newData;
    } else {
      return [];
    }
  } catch (error) {
    console.error("Error fetching priorities:", error);
    return [];
  }
};

const getCIFFOBList = async () => {
  try {
    const response = await genericGet({ url: GET_CIF_FOB_LIST });
    if (response.data && response.data.cifFobList) {
      const newData = response.data.cifFobList.map((cifFob) => ({
        id: cifFob.cifFobId,
        title: cifFob.cifFobName,
        priority: cifFob.priority,
        status: cifFob.status,
      }));
      return newData;
    } else {
      return [];
    }
  } catch (error) {
    console.error("Error fetching CIF/FOB list:", error);
    return [];
  }
};


const getShipmentTypes = async () => {
  try {
    const response = await genericGet({ url: GET_SHIPMENT_TYPES });
    if (response.data && response.data.shipmentTypes) {
      const newData = response.data.shipmentTypes.map((shipmentType) => ({
        id: shipmentType.shipmentTypeId,
        title: shipmentType.shipmentTypeName,
        priority: shipmentType.priority,
        status: shipmentType.status,
      }));
      return newData;
    } else {
      return [];
    }
  } catch (error) {
    console.error("Error fetching shipment types:", error);
    return [];
  }
};

const getCurrencyList = async () => {
  try {
    const response = await genericGet({ url: GET_CURRENCY_LIST });

    if (response.data && response.data.success && response.data.currencyList) {
      const currencyData = response.data.currencyList.map((currency) => ({
        id: currency.id,
        name: currency.name,
        // title: currency.currency,
        title: `${currency.currency_symbol} ${currency.currency} - ${currency.name} `,
        currencyName: currency.currency_name,
        currencySymbol: currency.currency_symbol,
      }));
      return currencyData;
    } else {
      return [];
    }
  } catch (error) {
    console.error('Error fetching currency list:', error);
    return [];
  }
};

const getSuppliersList = async () => {
  try {
    const authToken = sessionStorage.getItem('accessToken');
    const payload = {
      companyTypeId: 1,
    };

    const response = await axios.post(GET_SUPPLIERS_LIST, payload, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });

    if (response.data && response.data.success && response.data.clientCompanies) {
      const suppliersData = response.data.clientCompanies.map((supplier) => ({
        id: supplier.clientCompanyId,
        title: supplier.clientCompanyName,

      }));
      return suppliersData;
    } else {
      return [];
    }
  } catch (error) {
    console.error('Error fetching suppliers list:', error);
    return [];
  }
};

const getCustumersList = async () => {
  try {
    const authToken = sessionStorage.getItem('accessToken');
    const payload = {
      companyTypeId: 2,
    };

    const response = await axios.post(GET_SUPPLIERS_LIST, payload, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });

    if (response.data && response.data.success && response.data.clientCompanies) {
      const suppliersData = response.data.clientCompanies.map((supplier) => ({
        id: supplier.clientCompanyId,
        title: supplier.clientCompanyName,
      }));
      return suppliersData;
    } else {
      return [];
    }
  } catch (error) {
    console.error('Error fetching suppliers list:', error);
    return [];
  }
};

const getContactPersonList = async () => {
  try {
    const response = await genericGet({ url: GET_CONTACT_PERSON_LIST });
    if (response.data && response.data.contacts) {
      const contactList = response.data.contacts.map((contact) => ({
        id: contact.contactId,
        title: `${contact.firstName} ${contact.lastName}`,
      }));
      return contactList;
    } else {
      return [];
    }
  } catch (error) {
    console.error("Error fetching contact person list:", error);
    return [];
  }
};
const getAlexxcansolsContactPersonList = async () => {
  try {
    const response = await genericGet({ url: GET_ALEXXCANSOLS_CONTACT_PERSON_LIST });
    if (response.data && response.data.contacts) {
      const contactList = response.data.contacts.map((contact) => ({
        id: contact.contactId,
        title: `${contact.firstName} ${contact.lastName}`,
      }));
      return contactList;
    } else {
      return [];
    }
  } catch (error) {
    console.error("Error fetching contact person list:", error);
    return [];
  }
};


const getClientCompany = async () => {
  try {
    const response = await genericGet({ url: GET_clientCompanies });
    if (response.data && response.data.clientCompanies) {
      const newData = response.data.clientCompanies.map((company) => ({
        id: company.clientCompanyId,
        title: company.clientCompanyName,
      }));
      return newData;
    } else {
      return [];
    }
  } catch (error) {
    console.error("Error fetching client companies:", error);
    return [];
  }
};
const getEnquiryCompany = async () => {
  try {
    const response = await genericGet({ url: ENQUIRY_COMPANY_LIST });

    if (response.data && response.data.enquiryCompany) {
      const newData = response.data.enquiryCompany.map((company) => ({
        id: company.clientCompanyId,
        title: company.companyName,
      }));
      return newData;
    } else {
      return [];
    }
  } catch (error) {
    console.error("Error fetching enquiry companies:", error);
    return [];
  }
};


// const getOwner = async () => {
//   try {
//     const response = await genericGet({ url: GET_LEAD_OWNER });
//     const response = await genericGet({ url: GET_ORG_USERS });
//     if (response.data && response.data.leadOwner) {
//       const newData = response.data.leadOwner.map((contact) => ({
//         id: contact.userId,
//         title: `${contact.firstName} ${contact.lastName}`,
//         email: contact.email,
//         mobile: contact.mobile,
//       }));
//       return newData;
//     } else {
//       return [];
//     }
//   } catch (error) {
//     console.error("Error fetching lead owners:", error);
//     return [];
//   }
// };
const getOwner = async () => {
  try {
    const response = await genericGet({ url: GET_ORG_USERS });

    if (response.data && response.data.companyUsers) {
      const newData = response.data.companyUsers.map((user) => ({
        id: user.userId,
        title: `${user.user.firstName} ${user.user.lastName}`,
        email: user.user.email,
        mobile: user.user.mobile,
      }));
      return newData;
    } else {
      return [];
    }
  } catch (error) {
    console.error("Error fetching company users:", error);
    return [];
  }
};


const getShippingLines = async () => {
  try {
    const response = await genericGet({ url: GET_SHIPPING_LINE });

    if (response.data && response.data.success && response.data.shippingLine) {
      const newShippingLines = response.data.shippingLine.map((line) => ({
        id: line.shippingLineId,
        title: line.shippingLineName,
        shortName: line.shortName,
        createdAt: line.createdAt,
        updatedAt: line.updatedAt,
      }));
      return newShippingLines;
    } else {
      return [];
    }
  } catch (error) {
    console.error("Error fetching shipping lines:", error);
    return [];
  }
};
const getFCLData = async () => {
  try {
    const response = await genericGet({ url: GET_FCL_LIST });
    if (response.data && response.data.success && response.data.fcl) {
      const fclData = response.data.fcl.map((fcl) => ({
        id: fcl.fclId,
        title: fcl.fclName,
        shortName: fcl.shortName,
        createdAt: fcl.createdAt,
        updatedAt: fcl.updatedAt,
      }));
      return fclData;
    } else {
      console.error('Failed to fetch FCL data:', response.data);
      return [];
    }
  } catch (error) {
    console.error('Error fetching FCL data:', error);
    return [];
  }
};

const getDirectListData = async () => {
  try {
    const response = await genericGet({ url: GET_DIRECT_LIST });
    if (response.data && response.data.success && response.data.directList) {
      const directListData = response.data.directList.map((direct) => ({
        id: direct.directId,
        title: direct.directName,
        priority: direct.priority,
        status: direct.status,
        createdAt: direct.createdAt,
        updatedAt: direct.updatedAt,
      }));
      return directListData;
    } else {
      console.error('Failed to fetch direct list data:', response.data);
      return [];
    }
  } catch (error) {
    console.error('Error fetching direct list data:', error);
    return [];
  }
};

const getFreightForwardAgencyData = async () => {
  try {
    const response = await genericGet({ url: GET_FREIGHT_FORWARD_AGENCY_LIST });
    if (response.data && response.data.success && response.data.freightForwardAgency) {
      const freightForwardAgencyData = response.data.freightForwardAgency.map((agency) => ({
        id: agency.agencyId,
        title: agency.agencyName,
        address: agency.address,
        countryId: agency.countryId,
        contactPerson: agency.contactPerson,
        phoneNo: agency.phoneNo,
        mobileNo: agency.mobileNo,
        emailId: agency.emailId,
        note: agency.note,
        createdAt: agency.createdAt,
        updatedAt: agency.updatedAt,
      }));
      return freightForwardAgencyData;
    } else {
      console.error('Failed to fetch freight forward agency data:', response.data);
      return [];
    }
  } catch (error) {
    console.error('Error fetching freight forward agency data:', error);
    return [];
  }
};

const getCustomClearingAgencyData = async () => {
  try {
    const response = await genericGet({ url: GET_CUSTOM_CLEARING_AGENCY_LIST });
    if (response.data && response.data.success && response.data.customClearingAgencyList) {
      const customClearingAgencyData = response.data.customClearingAgencyList.map((agency) => ({
        id: agency.chaId,
        title: agency.chaName,
        address: agency.address,
        countryId: agency.countryId,
        contactPerson: agency.contactPerson,
        phoneNo: agency.phoneNo,
        mobileNo: agency.mobileNo,
        emailId: agency.emailId,
        note: agency.note,
        createdAt: agency.createdAt,
        updatedAt: agency.updatedAt,
      }));
      return customClearingAgencyData;
    } else {
      console.error('Failed to fetch custom clearing agency data:', response.data);
      return [];
    }
  } catch (error) {
    console.error('Error fetching custom clearing agency data:', error);
    return [];
  }
};

const getPaymentType = async () => {
  try {
    const response = await genericGet({ url: GET_PAYMENT_TYPE_LIST });
    if (response.data && response.data.success && response.data.paymentType) {
      const paymentTypeData = response.data.paymentType.map((payment) => ({
        id: payment.paymentTypeId,
        title: payment.paymentName,
        createdAt: payment.createdAt,
        updatedAt: payment.updatedAt,
      }));
      return paymentTypeData;
    } else {
      console.error('Failed to fetch payment type data:', response.data);
      return [];
    }
  } catch (error) {
    console.error('Error fetching payment type data:', error);
    return [];
  }
};
const getReceiptType = async () => {
  try {
    const response = await genericGet({ url: GET_RECEIPT_TYPE_LIST });
    if (response.data && response.data.success && response.data.receiptType) {
      const receiptTypeData = response.data.receiptType.map((receipt) => ({
        id: receipt.receiptTypeId,
        title: receipt.receiptTypeName,
        createdAt: receipt.createdAt,
        updatedAt: receipt.updatedAt,
      }));
      return receiptTypeData;
    } else {
      console.error('Failed to fetch receipt type data:', response.data);
      return [];
    }
  } catch (error) {
    console.error('Error fetching receipt type data:', error);
    return [];
  }
};
const getExpenseLedgerList = async () => {
  try {
    const response = await genericGet({ url: GET_EXPENSE_LEDGER_LIST });

    if (response.data && response.data.success && response.data.expenseLedgerList) {
      const expenseLedgerData = response.data.expenseLedgerList.map((ledger) => ({
        id: ledger.expenseLedgerId,
        title: ledger.ledgerName,
        userId: ledger.userId,
        companyId: ledger.companyId,
        ledgerShortName: ledger.ledgerShortName,
      }));

      return expenseLedgerData;
    } else {
      console.error('Failed to fetch expense ledger data:', response.data);
      return [];
    }
  } catch (error) {
    console.error('Error fetching expense ledger data:', error);
    return [];
  }
};


const getshippingStatus = async () => {
  try {
    const response = await genericGet({ url: GET_SHIPPING_STATUS });
    if (response.data) {
      let newData = response.data?.shippingStatus.map((data) => ({
        id: data.shippingStatusId,
        title: data.title,
      }));
      return newData || [];
    } else {
      return [];
    }
  } catch {
    return [];
  }
};
const getProductsGroup = async () => {
  try {
    const response = await genericGet({ url: GET_PRODUCTS_GROUP });
    if (response.data) {
      let newData = response.data?.productsGroup.map((data) => ({
        id: data.productsGroupId,
        title: data.productsGroupName,
      }));
      return newData || [];
    } else {
      return [];
    }
  } catch {
    return [];
  }
};

const getUnitQualityCode = async () => {
  try {
    const response = await genericGet({ url: GET_UNIT_QUALITY_CODE });
    if (response.data) {
      const newData = response.data.unitQualityCode.map((data) => ({
        id: data.id,
        title: data.title,
      }));
      return newData || [];
    } else {
      return [];
    }
  } catch {
    return [];
  }
};
const getUnitList = async () => {
  try {
    const response = await genericGet({ url: GET_UNIT_LIST });
    if (response.data && response.data.success && response.data.unitMasters) {
      const unitList = response.data.unitMasters.map((unit) => ({
        id: unit.productsUnitId,
        title: unit.unitName,
        // formalName: unit.unitName,
        // unitQuality: unit.unitQuality?.title,
        // noOfDecimalPlaces: unit.noOfDecimalPlaces,
      }));
      return unitList;
    } else {
      console.error('Failed to fetch unit list data:', response.data);
      return [];
    }
  } catch (error) {
    console.error('Error fetching unit list data:', error);
    return [];
  }
};
const getVoucher = async () => {
  try {
    const response = await genericGet({ url: GET_VOUCHER });
    if (response.data && response.data.success && response.data.voucher) {
      const voucherList = response.data.voucher.map((voucher) => ({
        id: voucher.voucherId,
        title: voucher.voucherName,
      }));
      return voucherList;
    } else {
      console.error('Failed to fetch data:', response.data);
      return [];
    }
  } catch (error) {
    console.error('Error fetching data:', error);
    return [];
  }
};
const getPortMasters = async () => {
  try {
    const response = await genericGet({ url: GET_PORT_MASTERS });

    if (response.data && response.data.success && response.data.portMasters) {
      const portMastersList = response.data.portMasters.map((port) => ({
        id: port.portMastersId,
        title: `${port?.portName || ""}, ${port?.country?.name || ""}`.trim(),

      }));
      return portMastersList;
    } else {
      console.error("Failed to fetch data:", response.data);
      return [];
    }
  } catch (error) {
    console.error("Error fetching data:", error);
    return [];
  }
};

const getPartyLedger = async () => {
  try {
    const response = await genericGet({ url: GET_PARTY_LEDGER_LIST });

    if (response.data && response.data.success && response.data.partyLedgerList) {
      const partyLedgerList = response.data.partyLedgerList.map((ledger) => ({
        id: ledger.partyLedgerId,
        title: ledger.partyName || "",
      }));

      return partyLedgerList;
    } else {
      console.error("Failed to fetch Party Ledger list:", response.data);
      return [];
    }
  } catch (error) {
    console.error("Error fetching Party Ledger list:", error);
    return [];
  }
};

const getBlogStatusList = async () => {
  try {
    const response = await genericGet({ url: BLOG_STATUS_LIST });

    if (response.data && response.data.success && response.data.blogStatusList) {
      const blogStatusList = response.data.blogStatusList.map((status) => ({
        id: status.blogStatusId,
        title: status.statusName || "",
      }));

      return blogStatusList;
    } else {
      console.error("Failed to fetch Blog Status list:", response.data);
      return [];
    }
  } catch (error) {
    console.error("Error fetching Blog Status list:", error);
    return [];
  }
};

const getBlogCategoryList = async () => {
  try {
    const response = await genericGet({ url: BLOG_CATEGORY_LIST });

    if (response.data && response.data.success && response.data.blogCategoryList) {
      const blogCategoryList = response.data.blogCategoryList.map((category) => ({
        id: category.blogCategoryId,
        title: category.categoryName || "",
      }));

      return blogCategoryList;
    } else {
      console.error("Failed to fetch Blog Category list:", response.data);
      return [];
    }
  } catch (error) {
    console.error("Error fetching Blog Category list:", error);
    return [];
  }
};

const getDefaultCompanyList = async () => {
  try {
    const response = await genericGet({ url: GET_COMPANY });

    if (response?.data?.companies && Array.isArray(response.data.companies)) {
      const mappedCompanies = response.data.companies.map((c) => ({
        id: c.companyId,
        name: c.companyName,
        address: `${c.address}, ${c.addressLineOne}${c.addressLineTwo ? ", " + c.addressLineTwo : ""
          }`,
        city: c?.city?.name || "",
        state: c?.state?.name || "",
        country: c?.country?.name || "",
        pincode: c?.pincode || "",
        mobile: c?.mobile || "",
        email: c?.email || "",
        website: c?.website || "",
        isDefault: c.isDefault,
      }));
      const defaultCompany =
        mappedCompanies.find((c) => c.isDefault) || mappedCompanies[0];
      return { defaultCompany, companies: mappedCompanies };
    }

    return { defaultCompany: null, companies: [] };
  } catch (error) {
    console.error("Error fetching company list:", error);
    return { defaultCompany: null, companies: [] };
  }
};

const getPaymentToSupplier = async () => {
  const filterPayload = { paymentToId: [1, 3] };
  try {
    const response = await genericPost(GET_PAYMENT_TO_LIST, filterPayload, {});
    if (response.data && response.data.success && response.data.paymentToList) {
      const paymentToList = response.data.paymentToList.map((ledger) => ({
        id: ledger.paymentToId,
        title: ledger.paymentToName || "",
      }));
      console.log("✅ Payment To List:", paymentToList);
      return paymentToList;
    } else {
      console.error("❌ Failed to fetch Payment To list:", response.data);
      return [];
    }
  } catch (error) {
    console.error("🚨 Error fetching Payment To list:", error);
    return [];
  }
};
const getPaymentTocustomer = async () => {
  const filterPayload = { paymentToId: [2, 3] };
  try {
    const response = await genericPost(GET_PAYMENT_TO_LIST, filterPayload, {});
    if (response.data && response.data.success && response.data.paymentToList) {
      const paymentToList = response.data.paymentToList.map((ledger) => ({
        id: ledger.paymentToId,
        title: ledger.paymentToName || "",
      }));
      console.log("✅ Payment To List:", paymentToList);
      return paymentToList;
    } else {
      console.error("❌ Failed to fetch Payment To list:", response.data);
      return [];
    }
  } catch (error) {
    console.error("🚨 Error fetching Payment To list:", error);
    return [];
  }
};

const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

//Notes: comman data fetch and create to pass commanShipmentId-0 for import and 1 for export
const importShipmentId = 0;
const getCommanImportShipmentId = importShipmentId;

const exportShipmentId = 1;
const getCommanExportShipmentId = exportShipmentId;


// Round a number to the nearest whole number and return with 2 decimal places like .00
const getRoundAmount = (amount) => {
  if (typeof amount !== 'number') return null;
  const rounded = amount % 1 >= 0.5 ? Math.ceil(amount) : Math.floor(amount);
  return parseFloat(rounded.toFixed(2));
};

// getBusinessProfile.js
const getBusinessProfile = () => {
  try {
    const userDataString = sessionStorage.getItem("userData");
    if (!userDataString) return null;

    const userData = JSON.parse(userDataString);
    return userData?.authUser?.businessProfile || null;
  } catch (error) {
    console.error("Invalid userData in sessionStorage:", error);
    return null;
  }
};

const getSkipListOwner = [4, 5, 6, 7, 10, 13, 20, 22, 23, 24, 25, 26, 27,
  28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39,
  40, 41, 42, 43, 44, 45, 46, 47, 48];

const getSkipListBusiness = [49, 50, 51, 52, 53, 44];

const getColorById = (
  value,
  colorList = [],
  {
    matchKey = "colorId",
    valueKey = null,
    prefixLength = 2,
    defaultColor = "#000000",
    defaultBg = "#ffffff",
  } = {}
) => {
  if (!value || !colorList.length) {
    return {
      color: defaultColor,
      backgroundColor: defaultBg,
    };
  }
  const actualValue = valueKey ? value?.[valueKey] : value;

  const prefix = actualValue?.toString()?.slice(0, prefixLength);

  const match = colorList.find(
    (item) => item?.[matchKey]?.toString() === prefix
  );

  return {
    color: match?.color || defaultColor,
    backgroundColor: match?.backgroundColor || defaultBg,
  };
};


export {
  getIndustryType,
  getBusinessGroup,
  getLeadSource,
  getLeadStatus,
  getCompanies,
  getRating,
  getColorPlate,
  getCountries,
  getStates,
  getCities,
  getCompanyTypes,
  getCompanyOwnershipType,
  getCallPurposeType,
  getCallOutcomeType,
  getPrioritiesLossReasons,
  getCompanyModules,
  getContactDepartments,
  getContactGroups,
  getContactTypes,
  getModules,
  getTaskStatuses,
  getLeadStages,
  getPriorities,
  getCIFFOBList,
  getShipmentTypes,
  getCurrencyList,
  getSuppliersList,
  getCustumersList,
  getClientCompany,
  getContactPersonList,
  getAlexxcansolsContactPersonList,
  getOwner,
  getShippingLines,
  getFCLData,
  getDirectListData,
  getFreightForwardAgencyData,
  getCustomClearingAgencyData,
  getPaymentType,
  getReceiptType,
  getExpenseLedgerList,
  formatDate,
  getCommanImportShipmentId,
  getCommanExportShipmentId,
  getTitles,
  getshippingStatus,
  getUnitQualityCode,
  getUnitList,
  getVoucher,
  getProductsGroup,
  getPaymentMethod,
  getDocumentNameList,
  getCallType,
  getPaymentAgainst,
  getEnquiryCompany,
  getRoundAmount,
  getPortMasters,
  getPartyLedger,
  getPaymentToSupplier,
  getPaymentTocustomer,
  getDefaultCompanyList,
  getBusinessProfile,
  getSkipListBusiness,
  getSkipListOwner,
  getColorById,
  getBlogStatusList,
  getBlogCategoryList,


};


export const AccessDenied = () => {
  return (
    <div style={{ padding: "20px", textAlign: "center" }}>
      <h1>Access Denied</h1>
      <p>You do not have permission to view this page.</p>
    </div>
  );
};


export const hasViewPermission = (currentPath, rolePermissions) => {
  if (!Array.isArray(rolePermissions)) {
    return false;
  }

  const normalizedCurrentPath = currentPath.replace(/\/$/, ""); // Normalize URL
  const updatedPath = normalizedCurrentPath.substring(1)
  const permission = rolePermissions.find(
    (perm) => perm.companyModule?.moduleUrl == updatedPath
  );
  if (!permission) {
    return true;
  }

  return permission?.views === 1;
};
export const hasCreatePermission = (currentPath, rolePermissions) => {
  if (!Array.isArray(rolePermissions)) {
    return false;
  }

  const normalizedCurrentPath = currentPath.replace(/\/$/, ""); // Normalize URL
  const updatedPath = normalizedCurrentPath.substring(1)
  const permission = rolePermissions.find(
    (perm) => perm.companyModule?.moduleUrl == updatedPath
  );
  if (!permission) {
    return true;
  }

  return permission?.creates === 1;
};

export const hasEditPermission = (currentPath, rolePermissions) => {
  if (!Array.isArray(rolePermissions)) {
    return false;
  }

  const normalizedCurrentPath = currentPath.replace(/\/$/, ""); // Normalize URL
  const updatedPath = normalizedCurrentPath.substring(1)
  const permission = rolePermissions.find(
    (perm) => perm.companyModule?.moduleUrl == updatedPath
  );
  if (!permission) {
    return true;
  }

  return permission?.updates === 1;
};

export const hasDeletePermission = (currentPath, rolePermissions) => {
  if (!Array.isArray(rolePermissions)) {
    return false;
  }

  const normalizedCurrentPath = currentPath.replace(/\/$/, ""); // Normalize URL
  const updatedPath = normalizedCurrentPath.substring(1)
  const permission = rolePermissions.find(
    (perm) => perm.companyModule?.moduleUrl == updatedPath
  );
  if (!permission) {
    return true;
  }

  return permission?.deletes === 1;
};

export const handleExportPermission = (currentPath, rolePermissions) => {

  if (!Array.isArray(rolePermissions)) {
    return false;
  }

  const normalizedCurrentPath = currentPath.replace(/\/$/, ""); // Normalize URL
  const updatedPath = normalizedCurrentPath.substring(1)
  const permission = rolePermissions.find(
    (perm) => perm.companyModule?.moduleUrl == updatedPath
  );
  if (!permission) {
    return true;
  }

  return permission?.exports === 1;
}

export const HtmlContentRenderer = ({ html, className = '' }) => (
  <>
    <style>
      {`
        .html-content ol,
        .html-content ul {
          margin-block-start: 1em;
          margin-block-end: 1em;
          padding-inline-start: 15px;
        }
      `}
    </style>
    <div
      className={`html-content ${className}`}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  </>
);
